import { render } from "./padel-toggle.template.html?vue&type=template&id=7b49ef69&scoped=true"
import script from "./PadelToggle.vue?vue&type=script&lang=ts"
export * from "./PadelToggle.vue?vue&type=script&lang=ts"

import "./PadelToggle.vue?vue&type=style&index=0&id=7b49ef69&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b49ef69"

export default script